import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { GetCurrentUser } from "../../../services/UserService";

function PrivateOutlet() {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  if (!token) {
    return <Navigate to='/login' />;
  }

  const { data } = GetCurrentUser();

  if (data !== "Unauthorized") return <Outlet />;

  return <Navigate to='/login' />;
}

export default PrivateOutlet;
